/**
 * API Key 服务
 * API Key Service
 */

import apiClient from './api';
import type {
  APIKey,
  APIKeyListResponse,
  CreateAPIKeyRequest,
  CreateAPIKeyResponse,
  UsageLogsResponse,
} from '../types/apiKey';

const BASE_URL = '/room-api-keys';

/**
 * 查询 API Key 列表
 */
export async function getAPIKeyList(params: {
  page?: number;
  limit?: number;
  key_type?: 'room' | 'venue';
  venue_id?: number;
  room_id?: number;
  status?: 'active' | 'revoked';
}): Promise<APIKeyListResponse> {
  const response = await apiClient.get(`${BASE_URL}`, { params });
  return response.data;
}

/**
 * 获取 API Key 详情
 */
export async function getAPIKeyDetail(keyId: string): Promise<APIKey> {
  const response = await apiClient.get(`${BASE_URL}/${keyId}`);
  return response.data;
}

/**
 * 创建 API Key（统一接口）
 */
export async function createAPIKey(data: CreateAPIKeyRequest): Promise<CreateAPIKeyResponse> {
  const response = await apiClient.post(`${BASE_URL}`, data);
  return response.data;
}

/**
 * 撤销 API Key
 */
export async function revokeAPIKey(keyId: string): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.delete(`${BASE_URL}/${keyId}`);
  return response.data;
}

/**
 * 查询 API Key 使用日志
 */
export async function getAPIKeyUsageLogs(
  keyId: string,
  params: {
    page?: number;
    limit?: number;
    start_date?: string;
    end_date?: string;
  }
): Promise<UsageLogsResponse> {
  const response = await apiClient.get(`${BASE_URL}/${keyId}/usage-logs`, { params });
  return response.data;
}

const apiKeyService = {
  getAPIKeyList,
  getAPIKeyDetail,
  createAPIKey,
  revokeAPIKey,
  getAPIKeyUsageLogs,
};

export default apiKeyService;
